<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <NavTabs
      customClass="capitalize_title"
      :tabs="tabs"
      :activeTab="newActiveTab"
      @sendData="updateData"
    />

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>

import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher.vue';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import OtherInformations from '@/components/forms/technicalFile/cooling/forms/OtherInformations';
import EvaluationDate from '@/components/forms/technicalFile/boiler/forms/EvaluationDate.vue';
import SystemSpecifications from '@/components/forms/technicalFile/boiler/forms/SystemSpecifications.vue';
import Operation from '@/components/forms/technicalFile/boiler/forms/Operation.vue';
import History from '@/components/forms/technicalFile/boiler/forms/History.vue';
import lockService from '@/utilities/lockService';


export default {
    components: {
        NavTabs,
        SlotScopeWatcher,
        ValidationObserver,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            tabs: [],
            components: [EvaluationDate, SystemSpecifications, Operation, OtherInformations, History],
            empty: {
                evaluationDate: {},
                systemSpecifications: {
                    identifier: '',
                    manufacturer: '',
                    capacity: {
                        value: null,
                        units: null,
                    },
                    systemType: {
                        value: null,
                        option: null,
                    },
                    pressure: {
                        value: null,
                        units: null,
                    },
                    volumeDuringOperation: {
                        value: null,
                        units: null,
                    },
                },
                operation: {
                    dailyOperationTime: {
                        value: null,
                        units: null,
                    },
                    yearlyOperationTime: {
                        value: null,
                        units: null,
                    },
                },
                otherInformation: {
                    note: '',
                    files: [],
                },
            },
            data: {
                nodeInfo: null,
            },
            model: null,
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
            'hasPermission',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
        readonly() {
            return !this.hasPermission('techFiles.edit');
        },
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleUnload);
    },

    async created() {
        this.loading = true;
        await this.$store.dispatch('changeActiveTab', 0);
        await this.getNodeInfo();
        if (!this.units) {
            await this.loadUnits({ siteId: this.site.id, lang: this.userLang });
        }
        this.model = this.data.nodeInfo ? this.data.nodeInfo : this.empty;
        this.tabs = this.tableHeaders();
        this.loading = false;
    },
    beforeDestroy() {
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, 'TechnicalFileBoiler');
        }
        window.removeEventListener('beforeunload', this.handleUnload, 'TechnicalFileBoiler');
    },
    methods: {
        ...mapActions({
            loadUnits: 'getUnits',
        }),

        async getNodeInfo() {
            const { data } = await this.$rq.getNodeInfo(this.site.id, this.node.ref);
            if (Object.keys(data).length) this.data.nodeInfo = data;
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, 'TechnicalFileBoiler');
            }
        },
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: { ...this.model, readonly: this.readonly },
                name: this.$t(`technicalFile.boiler.step${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        updateData(newData) {
            this.model = { ...this.model, ...newData };
            this.$emit('sendData', this.model);
        },
    },

};
</script>
